import React from 'react';
import {Linking, Modal, Platform} from 'react-native';
import Styles from '../Styles';
import Localized from 'src/constants/AppStrings';
import AVText from '../elements/AVText';
import NavActions from 'src/actions/NavActions';
import {StyleSheet, View, Dimensions} from 'react-native';
import AVTouchableOpacity from 'src/components/elements/AVTouchableOpacity';
import CancelIcon from 'src/components/img/svg/CancelIcon';
import AppRoutes from 'src/AppRoutes';
import AlertCircleExclamation from 'src/components/img/AlertCircleExclamation';
import {withForwardedNavigationParams} from 'react-navigation-props-mapper';

import RoundedAppButton, {
  RoundedAppButtonType,
} from 'src/components/elements/RoundedAppButton';
import {getDescriber} from 'src/components/screens/sendSnack/descriptor/sendasnack/DescriptorType';
import {getButtonDescriber} from 'src/components/elements/buttonDescriptor/DescriptorType';
type ServerErrorDialogState = {
  showErrorModal: boolean;
};

export type ServerErrorDialogProps = {
  errorTitle: string;
  errorDesc: string;
  popToRoute?: string;
  errorBtnName?: string;
};

const screenWidth = Dimensions.get('window').width;
const screenHeight = Dimensions.get('window').height;
const modalWidth = screenWidth * 0.9;

class ServerErrorDialog extends React.Component<
  ServerErrorDialogProps,
  ServerErrorDialogState
> {
  constructor(props) {
    super(props);
    this.state = {
      showErrorModal: true,
    };
  }

  onModalClose = () => {
    this.setState({showErrorModal: false}, () => {
      if (this.props.popToRoute) {
        NavActions.popToRoute(AppRoutes.History, null);
      } else {
        NavActions.pop();
      }
    });
  };

  render() {
    return (
      <>
        {this.state.showErrorModal && (
          <Modal
            visible={this.state.showErrorModal}
            onDismiss={this.onModalClose}
            transparent={true}
          >
            <View style={styles.modalView}>
              <View style={styles.modalContainer}>
                <AVTouchableOpacity
                  accessible
                  accessibilityLabel={Localized.Buttons.cancel}
                  accessibilityRole="button"
                  aria-label={`X icon, Double tap to ${Localized.Buttons.cancel} offer details`}
                  role="button"
                  style={styles.errorModalTitleContainer}
                  onPress={this.onModalClose}
                  hitSlop={Styles.HitSlop_10}
                >
                  <CancelIcon />
                </AVTouchableOpacity>
                <View style={styles.modalViewContent}>
                  {<AlertCircleExclamation />}
                  <AVText
                    accessible={true}
                    accessibilityLabel={Localized.Labels.error_getting_receipt}
                    aria-label={Localized.Labels.error_getting_receipt}
                    style={[
                      styles.errorTitle,
                      {
                        marginTop: Styles.Spacing.m2,
                      },
                      getDescriber()?.snackDetailsBtnFontSTyle(),
                    ]}
                    maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm7}
                  >
                    {this.props.errorTitle}
                  </AVText>
                  <AVText
                    accessible={true}
                    accessibilityLabel={Localized.Labels.error_server}
                    aria-label={Localized.Labels.error_server}
                    style={[
                      styles.codeLabel,
                      {
                        marginTop: Styles.Spacing.m3,
                        textAlign: 'center',
                      },
                      getDescriber()?.snackDetailsBtnFontSTyle(),
                    ]}
                    maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm7}
                  >
                    {this.props.errorDesc}
                  </AVText>
                </View>

                <RoundedAppButton
                  buttonType={RoundedAppButtonType.Solid}
                  onPress={() => {
                    if (
                      this.props.errorBtnName?.toLowerCase() ===
                      Localized.Buttons.go_to_settings.toLowerCase()
                    ) {
                      this.onModalClose();
                      if (Platform.OS === 'ios') {
                        Linking.openURL('app-settings:');
                      } else {
                        Linking.openSettings();
                      }
                    } else {
                      this.onModalClose();
                    }
                  }}
                  buttonViewStyle={{
                    overflow: 'hidden',
                    borderRadius: 32,
                    alignSelf: 'center',
                    marginTop: Styles.Spacing.m3 + Styles.Spacing.m2,
                    paddingHorizontal: 24,
                    paddingVertical: 12,
                    backgroundColor:
                      getButtonDescriber().checkRoundedBtnColor(),
                  }}
                  buttonContainerStyle={{
                    alignSelf: 'center',
                  }}
                  accessibilityLabelValue={`${
                    this.props.errorBtnName || Localized.Buttons.okay
                  }`}
                  titleText={this.props.errorBtnName || Localized.Buttons.okay}
                  maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm1}
                  textStyle={[styles.applyButtonText, {textTransform: 'none'}]}
                />
              </View>
            </View>
          </Modal>
        )}
      </>
    );
  }
}

const styles = StyleSheet.create({
  modalViewContent: {
    marginTop: 50,
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalView: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: 25,
    marginRight: 25,
  },
  modalContainer: {
    paddingBottom: 24,
    maxHeight: screenHeight / 1.2,
    width: modalWidth,
    backgroundColor: Styles.white,
    borderRadius: Styles.Spacing.m3,
    paddingHorizontal: 25,
  },
  errorModalTitleContainer: {
    justifyContent: 'flex-end',
    position: 'absolute',
    top: Styles.Heights.h1,
    right: Styles.Heights.h1,
  },
  applyButtonText: {
    color: Styles.white,
    fontSize: Styles.Fonts.f1,
    fontWeight: '700',
    textAlign: 'center',
    marginLeft: Styles.Spacing.m1,
    fontFamily: Styles.FontFamily.robotoRegular,
    textTransform: 'uppercase',
  },
  errorTitle: {
    color: Styles.black,
    fontSize: Styles.Fonts.sectionHeader,
    fontWeight: '700',
    fontFamily: Styles.FontFamily.robotoRegular,
  },
  codeLabel: {
    color: Styles.black,
    fontSize: Styles.Fonts.f1,
    fontWeight: '400',
    fontFamily: Styles.FontFamily.robotoRegular,
  },
});

export default withForwardedNavigationParams<ServerErrorDialogProps>()(
  ServerErrorDialog,
);
